import { render, staticRenderFns } from "./messageDetail.vue?vue&type=template&id=697fd90c&scoped=true"
import script from "./messageDetail.vue?vue&type=script&lang=js"
export * from "./messageDetail.vue?vue&type=script&lang=js"
import style0 from "./messageDetail.vue?vue&type=style&index=0&id=697fd90c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "697fd90c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('697fd90c')) {
      api.createRecord('697fd90c', component.options)
    } else {
      api.reload('697fd90c', component.options)
    }
    module.hot.accept("./messageDetail.vue?vue&type=template&id=697fd90c&scoped=true", function () {
      api.rerender('697fd90c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/messageCenter/components/messageDetail.vue"
export default component.exports